import React from 'react';
import ReactDOM from 'react-dom';
import './fonts/fonts.css';
import './index.css';
import App from './App';

// ELECTRON SPECIFIC
const isElectron = typeof window.require !== "undefined"

if (isElectron) {

  const { remote, ipcRenderer } = window.require('electron')
  let iniConfig = remote.getGlobal('iniConfig')

  let logFnE = (message) => {
    console.log("**LOG**", message)
    ipcRenderer.send('write_log', message)
  }

  let exitRequested = function(){
    ipcRenderer.send('exit_requested')
  }

  main(iniConfig, logFnE, exitRequested)

} else {

  /* IE fallback because 'console' and 'console.log()' are only available after you have opened the Developer Tools (F12). */
  var logFnB;
  if (window.console) 
    logFnB = ( msg ) => { console.log( msg ) };
  else /*if (typeof console === "undefined" || typeof console.log === "undefined") */ 
  { 
    logFnB = (msg) => { /* nothing */ };
  }
    const exitRequestedUnavailable = () => {
    console.log("Appel de 'exitRequested' (pas disponible dans le browser)");
  }

  main(window.CONFIG, logFnB, exitRequestedUnavailable);
}

function main(config, logFn, exitRequested) 
{
  logFn("******************* Démarrage de l'application *******************");
  logFn("config > "+ JSON.stringify({ config : config }, null, 2));
  
  ReactDOM.render(<App config={config} logFn={logFn} onExitRequested={exitRequested}/>, document.getElementById('root'));
}




// WEBPACK FOOTER //
// ./src/index.js